module.exports = __webpack_public_path__ + "static/media/circle_check.7ec3ce48.svg";